const businessConfig = {
  domain: process.env.NEXT_PUBLIC_DOMAIN,
  minimumPreparationTimeMinutes: 14,
  otpLength: 5,
  refundInquiryInterval: 1 * 60 * 60 * 1000,
};

export default businessConfig;
